module.exports = __webpack_public_path__ + "img/curly.28965708.svg";